import { Component, OnInit } from '@angular/core';
import 'rxjs/add/observable/empty';
import { MatDialogRef } from '@angular/material';
import { StateService } from '@app/shared';
import { DriverNoticeService } from '@app/driver-notice/driver-notice.service';
import { BehaviorSubject } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-driver-notice',
  templateUrl: './driver-notice.component.html',
  styleUrls: ['./driver-notice.component.scss']
})
export class DriverNoticeComponent implements OnInit {
  input = '';
  driversList = [];
  selectedDrivers = [];
  services = [];
  service;
  removable = true;
  message = '';
  filteredDrivers = [];
  LIST_SIZE = 20;
  currentLength = 20;
  groups = [];
  selectedGroups = [];
  selectAll = 'selectAll';
  selectedGroupsSub = new BehaviorSubject([]);
  isDisabledSendBtn = false;

  mesMaxSize = 1024;

  constructor(
    public dialogRef: MatDialogRef<DriverNoticeComponent>,
    public driverNoticeService: DriverNoticeService,
    private state: StateService
  ) {}

  ngOnInit() {
    this.state.getParameter('services').subscribe(res => {
      this.services = res;
      this.service = res[0].id;
      this.loadDrivers();
    });
  }

  loadDrivers() {
    this.selectedDrivers = [];
    this.selectedGroups = [];
    this.driverNoticeService.getDrivers(this.service).subscribe(res => {
      this.driversList = res.map(driver => {
        driver.groups = driver.groups || ['Базовая автоколонна'];
        return driver;
      });

      this.groups = Array.from(
        new Set([].concat(...res.map(driver => driver.groups)))
      );
      this.currentLength = this.LIST_SIZE;
      this.rebuildList();
      this.selectedGroupsSub.subscribe(res => {
        this.selectedDrivers = this.driversList.filter(driver =>
          driver.groups.find(group =>
            this.selectedGroups.find(el => el === group)
          )
        );
      });
    });
  }

  getFullName(driver) {
    return `${driver.callsign} ${driver.last_name} ${driver.first_name}`;
  }

  /*remove(driver) {
    this.selectedDrivers = this.selectedDrivers.filter(
      el => el.id !== driver.id
    );
  }*/

  scroll() {
    this.currentLength = Math.min(
      this.currentLength + this.LIST_SIZE,
      this.driversList.length
    );
    this.rebuildList();
  }

  rebuildList() {
    this.filteredDrivers = this.driversList.map(el => {
      el.visible =
        ~el.callsign.search(this.input) ||
        ~el.first_name.search(this.input) ||
        ~el.last_name.search(this.input);
      return el;
    });
    console.log(this.currentLength, this.filteredDrivers.length);
    let lastIndex = this.currentLength;
    this.filteredDrivers.forEach((driver, i) => {
      if (i < lastIndex) {
        if (!this.filteredDrivers[i].visible) {
          lastIndex++;
        }
      } else {
        this.filteredDrivers[i].visible = false;
      }
    });
    // this.selectedDrivers = [...this.selectedDrivers];
  }

  send() {
    this.isDisabledSendBtn = true;
    this.driverNoticeService
      .sendMessage(
        this.selectedDrivers.map(el => {
          return { receiver_id: el.id };
        }),
        this.message,
        this.service
      )
      .subscribe(res => {
        this.isDisabledSendBtn = false;
        this.dialogRef.close();
      });
  }

  selectAllChange() {
    if (this.selectedGroups.find(el => el == this.selectAll)) {
      this.selectedGroups = [...this.groups, this.selectAll];
      this.selectedDrivers = this.driversList;
    } else {
      this.selectedGroups = [];
      this.selectedDrivers = [];
    }

    //this.selectedGroupsSub.next(this.selectedGroups);
  }

  getSelectCaption(selectedGroups: Array<string>) {
    if (selectedGroups == []) {
      return 'SELECT_DRIVERS_BY_GROUP';
    }
    if (~selectedGroups.indexOf(this.selectAll)) {
      return this.selectAll.toUpperCase();
    }
    return selectedGroups.join(', ');
  }

  groupsSelectionChange(event) {
    this.selectedGroupsSub.next([]);
  }

  sendToAll() {
    this.driverNoticeService
      .sendMessageToAll(this.service, this.message)
      .subscribe(es => {
        this.dialogRef.close();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-notice/driver-notice/driver-notice.component.ts